import { useEffect, useState } from "react";
import { Badge, Form, Offcanvas, Spinner } from "react-bootstrap";
import { studySubjectDiscontinueReasonServices } from "../../../../APIServices/CTMS/SubjectManagement/studySubjectDiscontinueReasonServices";
import { useParams } from "react-router";
import { studySubjectDiscontinueStatusServices } from "../../../../APIServices/CTMS/SubjectManagement/studySubjectDiscontinueStatusServices";

const Discontinue = ({
  Show,
  Hide,
  Title,
  subjectStatusLoader,
  updateStudySubjectStatus,
  reason,
  setReason,
  category,
  setCategory,
  remark,
  setRemark
}) => {
  const [reasonList, setReasonList] = useState([]);
  const [categoryList, setCategoryList] = useState([]);
  const [reasonType, setReasonType] = useState("dynamic");
  const { studyId } = useParams()

  const getStudySubjectDiscontinueReasonData = async () => {
    let data = await studySubjectDiscontinueReasonServices.getStudySubjectDiscontinueReasonData("active", studyId)
    setReasonList(data?.data || [])
  }

  const getStudySubjectDiscontinueStatusData = async () => {
    let data = await studySubjectDiscontinueStatusServices.getStudySubjectDiscontinueStatusData("active", studyId)
    setCategoryList(data?.data || [])
  }

  useEffect(() => {
    getStudySubjectDiscontinueReasonData()
    getStudySubjectDiscontinueStatusData()
  }, []);

  return (
    <Offcanvas show={Show} onHide={Hide} placement="end">
      <Offcanvas.Header closeButton>
        <Offcanvas.Title>{Title}</Offcanvas.Title>
      </Offcanvas.Header>
      <Offcanvas.Body>
        <Form.Group className="mb-1">
          <Form.Label className="mb-1 fw-bold">Category</Form.Label>
          <Form.Select
            value={category}
            onChange={(e) => setCategory(e.target.value)}
          >
            <option value="">Select Category</option>
            {categoryList?.map((item => (
              <option value={item?.category}>
                {item?.category}
              </option>
            )))}
          </Form.Select>
        </Form.Group>
        <Form.Group className="mb-1">
          <div className="hstack gap-2">
            <Form.Label className="fw-bold mb-1">
              Reason{" "}
              <abbr title="Required" className="text-danger">
                *
              </abbr>
            </Form.Label>
            <Badge onClick={() => { setReasonType(reasonType === "dynamic" ? "custom" : "dynamic"); setReason("") }} bg="primary" className="mb-1 text-capitalize CP rounded-1" style={{ fontSize: 9 }}>{reasonType === "dynamic" ? "custom" : "dynamic"}</Badge>
          </div>
          {reasonType === "dynamic" ?
            <Form.Select
              onChange={(e) => setReason(e.target.value)}
              style={{ fontSize: 12 }}
              className="br3"
              value={reason}
            >
              <option value="">Select Reason</option>
              {reasonList?.map((item => (
                <option value={item?.reason}>
                  {item?.reason}
                </option>
              )))}
            </Form.Select>
            :
            <Form.Control
              className="br3"
              onChange={(e) => setReason(e.target.value)}
              rows={3}
              value={reason}
              placeholder="Enter Reason"
              as="textarea"
            />
          }
        </Form.Group>
        <Form.Group className="mb-1">
          <Form.Label className="mb-1 fw-bold">Remark</Form.Label>
          <Form.Control
            as="textarea"
            rows={3}
            placeholder="Enter Remark"
            value={remark}
            onChange={(e) => setRemark(e.target.value)}
          />
        </Form.Group>
      </Offcanvas.Body>
      <div className="p-2 border-top bg-light text-end">
        <button
          disabled={!category || !reason || subjectStatusLoader}
          className="updateProfile"
          onClick={updateStudySubjectStatus}
        >
          {subjectStatusLoader ? (
            <div className="hstack gap-2">
              <Spinner size="sm" /> Disconting...
            </div>
          ) : (
            "Discontinue"
          )}
        </button>
      </div>
    </Offcanvas>
  );
};

export default Discontinue;